"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledPopover = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _context = require("../../context");

var _utilities = require("../../_utils/utilities");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject23() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n          width: 100%;\n        "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n          margin-top: 7px;\n        "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  pointer-events: ", ";\n  ", ";\n  ", ";\n  &:focus-within {\n    outline: none;\n    pointer-events: none;\n    > ", " {\n      opacity: 1;\n      visibility: visible;\n\n      /* don't let pointer-events affect descendant elements */\n      pointer-events: auto;\n    }\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n          &:after,\n          &:before {\n            content: '';\n            width: 0;\n            height: 0;\n            border-style: solid;\n            ", "\n            position: absolute;\n            ", ";\n          }\n        "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0 6px 8px rgba(22,22,22, 0.15);\n  border-radius: 2px;\n  position: absolute;\n  z-index: 35;\n  width: ", ";\n  width: ", ";\n  min-width:  ", ";;\n  max-width: ", ";\n  ", " \n  ", "\n  /* opacity to fake immediate toggle */\n  opacity: 0;\n  visibility: hidden;\n  transition: visibility 0.5s;\n\n  ", "\n  &:after {\n    ", ";\n  }\n  &:before {\n    ", ";\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n        border-width: 5.5px 6px 5.5px 0;\n        border-color: transparent ", "\n          transparent transparent;\n        right: 100%;\n      "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n        border-width: 5.5px 0 5.5px 6px;\n        border-color: transparent transparent\n          transparent ", ";\n        left: 100%;\n      "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        border-width: 6px 5.5px 0 5.5px;\n        border-color: ", " transparent\n          transparent transparent;\n        top: 100%;\n      "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        border-width: 0 5.5px 6px 5.5px;\n        border-color: transparent transparent\n          ", " transparent;\n        bottom: 100%;\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        ", ": 50%;\n        transform: translate", "(-50%);\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["top: 0;"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["bottom: 0;"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["right: 0;"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["left: 0;"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        left: 100%;\n        margin: ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        right: 100%;\n        margin: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        bottom: 100%;\n        margin: ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        top: 100%;\n        margin: ", ";\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColors = function getColors(props) {
  return (0, _versions.getColor)(props, 'tooltip');
};

var getPopoverMargin = function getPopoverMargin(props) {
  return props.pointed ? _tokens.spacing.xsmall : 0;
};

var getPopoverPosition = function getPopoverPosition(position) {
  switch (position) {
    case 'bottom':
      return (0, _styledComponents.css)(_templateObject(), function (props) {
        return "".concat(getPopoverMargin(props), " 0");
      });

    case 'top':
      return (0, _styledComponents.css)(_templateObject2(), function (props) {
        return "".concat(getPopoverMargin(props), " 0");
      });

    case 'left':
      return (0, _styledComponents.css)(_templateObject3(), function (props) {
        return "0 ".concat(getPopoverMargin(props));
      });

    case 'right':
    default:
      return (0, _styledComponents.css)(_templateObject4(), function (props) {
        return "0 ".concat(getPopoverMargin(props));
      });
  }
};

var getPopoverAlignment = function getPopoverAlignment(props, isPopover) {
  var isOnXaxis = props.position === 'left' || props.position === 'right';

  switch (props.align) {
    case 'right':
      return (0, _styledComponents.css)(_templateObject5());

    case 'left':
      return (0, _styledComponents.css)(_templateObject6());

    case 'top':
      return (0, _styledComponents.css)(_templateObject7());

    case 'bottom':
      return (0, _styledComponents.css)(_templateObject8());

    case 'middle':
    default:
      if (!props.icon && isPopover) return null;
      if (!isPopover) return (0, _styledComponents.css)(_templateObject9(), isOnXaxis ? 'top' : 'left', isOnXaxis ? 'Y' : 'X');
  }
};

var getPopoverArrow = function getPopoverArrow(props, color) {
  var arrowColor = getColors(props)[color];

  switch (props.position) {
    case 'bottom':
      return (0, _styledComponents.css)(_templateObject10(), arrowColor);

    case 'top':
      return (0, _styledComponents.css)(_templateObject11(), arrowColor);

    case 'left':
      return (0, _styledComponents.css)(_templateObject12(), arrowColor);

    case 'right':
    default:
      return (0, _styledComponents.css)(_templateObject13(), arrowColor);
  }
};

var StyledPopover = _styledComponents["default"].div(_templateObject14(), function (props) {
  return (0, _versions.getSpecificColor)(props, 'white');
}, function (props) {
  return getColors(props).text;
}, function (props) {
  return getColors(props).border;
}, function (props) {
  return props.fullWidth ? '100%' : 'max-content';
}, function (props) {
  if (props.fullWidth) {
    return '100%';
  }

  if ((0, _utilities.validCssUnit)(props.listWidth)) {
    return props.listWidth;
  }

  return 'max-content';
}, function (props) {
  return (0, _utilities.validCssUnit)(props.listWidth) && !props.fullWidth ? props.listWidth : '160px';
}, function (props) {
  return props.fullWidth ? '100%' : '640px';
}, function (props) {
  return getPopoverPosition(props.position);
}, function (props) {
  return getPopoverAlignment(props, true);
}, function (props) {
  return props.pointed ? (0, _styledComponents.css)(_templateObject15(), function (props) {
    return getPopoverAlignment(props);
  }, ''
  /* margin-left: -5px; */
  ) : (0, _styledComponents.css)(_templateObject16());
}, function (props) {
  return props.pointed ? getPopoverArrow(props, 'background') : (0, _styledComponents.css)(_templateObject17());
}, function (props) {
  return props.pointed ? getPopoverArrow(props, 'text') : (0, _styledComponents.css)(_templateObject18());
});

exports.StyledPopover = StyledPopover;

var ContentPopover = _styledComponents["default"].div(_templateObject19(), function (props) {
  return props.contentDisabled ? 'none' : 'auto';
}, function (props) {
  return props.adjustVerticalAlign ? (0, _styledComponents.css)(_templateObject20()) : (0, _styledComponents.css)(_templateObject21());
}, function (props) {
  return props.fullWidth ? (0, _styledComponents.css)(_templateObject22()) : (0, _styledComponents.css)(_templateObject23());
}, StyledPopover);

var Popover = function Popover(_ref) {
  var content = _ref.content,
      props = _objectWithoutProperties(_ref, ["content"]);

  return _react["default"].createElement("div", null, _react["default"].createElement(ContentPopover, {
    tabIndex: '0',
    fullWidth: props.fullWidth,
    adjustVerticalAlign: props.adjustVerticalAlign,
    contentDisabled: props.contentDisabled
  }, _react["default"].createElement(StyledPopover, props, content), props.children));
};

Popover.defaultProps = {
  align: 'middle',
  pointed: false,
  position: 'bottom',
  fullWidth: false,
  adjustVerticalAlign: true
};
Popover.displayName = 'Popover';

var _default = (0, _context.withVersion)(Popover);

exports["default"] = _default;